import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import AdditionalInfoForm from './components/AdditionalInfoForm';

export default function Day21AdditionalCreatePage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.addDay21Additional')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<AdditionalInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
